module.exports = __webpack_public_path__ + "static/media/billing.581c246e.svg";